import { C } from "./theme";
import { KindIcon } from "./kindIcons";

// Today, Radar, Goals and Tasks draw the same icons as their Home tiles.
const kindIcon = (id) => (color) => <KindIcon id={id} color={color} />;

export function BottomNav({ active, onNav }) {
  const navIcons = {
    today: kindIcon("today"),
    radar: kindIcon("radar"),
    goals: kindIcon("goals"),
    tasks: kindIcon("tasks"),
    chat: (color) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
      </svg>
    ),
    home: (color) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V21h14V9.5"/><path d="M10 21v-6h4v6"/>
      </svg>
    ),
  };
  // Craig's order (23 Oct 2026), when My Plan was parked and Home took its place. Dreams, Fears, Key Dates and
  // Learn open from Home's tiles and light no item here; Settings opens from the top bar's gear.
  const items = [{ id: "home", label: "Home" }, { id: "today", label: "Today" }, { id: "radar", label: "Radar" }, { id: "goals", label: "Goals" }, { id: "tasks", label: "Tasks" }, { id: "chat", label: "Chat" }];
  return <nav aria-label="Main" style={{
    height: 64,
    padding: "0 4px 4px",
    background: C.bg,
    borderTop: `1px solid ${C.border}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    flexShrink: 0,
    position: "sticky",
    bottom: 0,
    zIndex: 50,
    width: "100%",
  }}>
    {items.map(item => {
      const color = item.id === active ? C.accent : C.textMid;
      return (
        <button key={item.id} onClick={() => onNav(item.id)} aria-current={item.id === active ? "page" : undefined}
          style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 3, cursor: "pointer", flex: 1, minHeight: 52, padding: "6px 0", border: "none", borderRadius: 10, fontFamily: "inherit", background: item.id === active ? C.accentLight : "transparent", transition: "background 0.15s" }}>
          <span aria-hidden="true" style={{ lineHeight: 0 }}>{navIcons[item.id](color)}</span>
          <span style={{ fontSize: 12, fontWeight: 600, color, letterSpacing: "0.04em" }}>{item.label}</span>
        </button>
      );
    })}
  </nav>;
}
